import classnames from 'classnames';
import * as React from 'react';

import ItemGrid from './ItemGrid';

type ItemGridWithLoadingProps<T> = {
    horizontalHidden: boolean;
    isLoading: boolean;
    skeletonCount?: number;
    renderSkeleton?: () => React.ReactNode;
} & React.ComponentPropsWithoutRef<typeof ItemGrid<T>>;

const ItemGridWithLoading = <T,>(
    props: ItemGridWithLoadingProps<T>,
    ref?: React.Ref<HTMLUListElement>,
) => {
    if (!props.isLoading && props.items?.length === 0) return null;

    return props.isLoading ? (
        <ItemGrid
            ref={ref}
            cellsInRow={props.cellsInRow}
            gridClasses={classnames(
                props.horizontalHidden && 'Grid--horizontalHidden',
                props.gridClasses,
            )}
            itemUniqueKey={(item, index) => `${item.identifier}_${index}`}
            items={[...Array(props.skeletonCount || props.cellsInRow)].map((x, index) => ({
                identifier: index.toString(),
            }))}
            renderItem={() => (props.renderSkeleton ? props.renderSkeleton() : null)}
            renderAtRowStart={props.renderAtRowStart}
            renderAtRowEnd={props.renderAtRowEnd}
            itemClasses={props.itemClasses}
            noDefaultClasses={props.noDefaultClasses}
            styles={props.styles}
        />
    ) : (
        <ItemGrid
            ref={ref}
            cellsInRow={props.cellsInRow}
            gridClasses={classnames(
                props.horizontalHidden && 'Grid--horizontalHidden',
                props.gridClasses,
            )}
            items={props.items}
            itemUniqueKey={props.itemUniqueKey}
            renderItem={props.renderItem}
            renderAtRowStart={props.renderAtRowStart}
            renderAtRowEnd={props.renderAtRowEnd}
            itemClasses={props.itemClasses}
            noDefaultClasses={props.noDefaultClasses}
            styles={props.styles}
        />
    );
};

export default React.forwardRef(ItemGridWithLoading);
